module.exports = __webpack_public_path__ + "static/media/activate_card.1a779761.png";